import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { EMAIL_INFO } from 'config/appconstants';

export const CheckoutGatewayClosedDetails = () => {
  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">What happens next?</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">
            An email request has been sent to the property host with your reservation details. Most responses will occur
            on the same day. The property host will likely contact you to clarify house rules before approving your
            reservation request.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" fontWeight="500">
            The process is...
          </Typography>
          <ul>
            <li>Reservation request is sent (completed)</li>
            <li>The property host will approve or reject your request.</li>
            <li>If approved, you will receive an email with a payment link to finalize the credit card payment.</li>
          </ul>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">
            Keep an eye out for an email notification of the request being either approved or rejected within the next
            24 hours with instructions how to complete the payment. If the property host does not respond, please contat
            them using the contact form on the property listing.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">
            <strong>Note:</strong> If you are asked to make a payment directly to the host and not through the website
            secure credit card form, please contact {`${EMAIL_INFO}`} immediately. Credit card payments through the
            website are required and provides the highest level of security and protections.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
